import { Component, Renderer2, ViewChild, Input } from '@angular/core';
import { CommonService } from '../../frontend-services/common.service';
import { interval } from 'rxjs/observable/interval';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
  counter:any=0;
  @ViewChild('message') message:string="";
  @Input('id') loaderId=null;
  @Input('isContainer') isContainer=false;
  lastUpdated:number=null;
  public isVisible=false;
  constructor(private service:CommonService,private renderer: Renderer2,private router: Router) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })
  }
  
  ngOnInit() {
    this.service.showLoader$.subscribe((data)=>{ if(data&&data.flag) this.show(data); });
    this.service.hideLoader$.subscribe((data)=>{ if(data&&data.flag) setTimeout(()=>this.hide(data), 400); });
    interval(1000 * 30).subscribe(x => {
      if(this.counter>0&&((this.lastUpdated+(1000*30))<this.service.date().getTime())){
        this.reset();
        console.log("loader is reset",this.counter);
        /* if(window.location.hostname=="localhost"){
          this.service.alert("Loader was forcefully reset. Please check console/network tab for the error. FYI, you are getting this error because you are running this app on the local.");
        } */
      }
    });
  }
  show(data:any=null){
    switch(typeof(data)){
      case "number":  this.counter+=data;  break;
      case "string":  this.message=data;this.counter++;  break;
      case "object":  
                      
                      if(data&&data.id&&data&&data.id==this.loaderId) this.isVisible=true;
                      else {
                        if(data&&data.counter) this.counter+=data.counter;
                        else this.counter++;
                        if(data&&data.message) this.message=data.message;
                      }
                      break;
      default:        this.counter++;
    }
    this.lastUpdated=this.service.date().getTime();
    if(!this.loaderId&&!(data&&data.id&&data&&data.id)) this.renderer.addClass(document.body, 'loading');
    //console.log("loader show",this.loaderId,data,"counter",this.counter);
  }
  hide(data:any=null){
    if(data&&typeof(data)=="object"&&data.id&&data&&data.id==this.loaderId) this.isVisible=false;
    else {
      if(this.counter>0) this.counter--;
      if(this.counter==0) this.reset();
    }
    //console.log("loader hide",this.loaderId,data,"counter",this.counter);
  }
  reset(){
    this.counter=0;
    this.message="";
    this.renderer.removeClass(document.body, 'loading');
    this.isVisible=false;
  }
  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: any): void {
    if (event instanceof NavigationStart) {
      this.show();
    }
    if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
      setTimeout(()=>this.hide(), 400);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/common/loader/loader.component.ts